<template>
  <div class="language-switcher">
    <Dropdown
      :options="languageOptions"
      optionLabel="label"
      optionValue="code"
      v-model="selectedLanguage"
      @change="changeLanguage"
      placeholder="Select Language"
      class="p-dropdown"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import Dropdown from "primevue/dropdown";

export default defineComponent({
  name: "LanguageSwitcher",
  components: { Dropdown },
  setup() {
    const { locale } = useI18n();

    // Definiši opcije za jezike
    const languageOptions = [
      { code: "en", label: "English" },
      { code: "cro", label: "Croatian" },
      { code: "ar-bh", label: "Bahraini Arabic" }, // Dodaj Bahreinski arapski
    ];

    // Proveri localStorage za prethodno izabrani jezik
    const selectedLanguage = ref(
      localStorage.getItem("language") || locale.value
    );

    // Inicijalizuj jezik pri učitavanju komponente
    onMounted(() => {
      if (localStorage.getItem("language")) {
        locale.value = localStorage.getItem("language") as string;
      }
    });

    // Funkcija za promenu jezika
    const changeLanguage = () => {
      locale.value = selectedLanguage.value;
      localStorage.setItem("language", selectedLanguage.value); // Sačuvaj jezik u localStorage
    };

    return {
      languageOptions,
      selectedLanguage,
      changeLanguage,
    };
  },
});
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
